<template>
  <div class="member-page">
    <common-title titleName="会员中心" v-if="!isHideTitle" :isAPPShow="true" />
    <div class="member__top" v-if="!isMini"></div>
    <faq-modal :show="isFaqShow" :content="faq" @close="closeFaq" />

    <open-member-popup
      :show="isOpenPopup"
      :activeTab="activeTab"
      :cardTitle="currentTabLabel"
      :benefitList="benefitList"
      :packages="currentTabPackages"
      :memberTierLevel="memberTierLevel"
      :showTrial="!userMemberInfo.level && showTrialBtn"
      @close="closeOpenPopup"
      @pay="onOpenPay"
      @upgrade="onOpenUpgrade"
      @trial="onOpenTrial"
    />

    <!-- 顶部背景区：会员卡切换 + 用户信息 + 权益入口 -->
    <div class="member-hero" :class="`member-hero--${activeTab}`">
      <div class="member-tabs">
        <div
          v-for="tab in tabList"
          :key="tab.key"
          class="member-tabs__item"
          :class="{ 'is-active': activeTab === tab.memberLevel }"
          @click="setTabActive(tab.memberLevel)"
        >
          {{ tab.label }}
        </div>
        <div
          class="member-tabs__indicator"
          :style="{ transform: `translateX(${activeTabIndex * 100}%)` }"
        ></div>
      </div>

      <div class="member-user-card">
        <div class="member-user-card__main">
          <div class="member-user-card__profile">
            <img
              v-if="userInfo.avatar"
              class="member-user-card__avatar"
              :src="userInfo.avatar"
              alt=""
            />
            <img
              v-else
              class="member-user-card__avatar"
              src="@/assets/img/personalImg/defaultAvatar.png"
              alt=""
            />
            <div class="member-user-card__meta">
              <span
                v-if="userInfo.id"
                class="member-user-card__name"
              >{{ userInfo.nickName }}</span>
              <span
                v-else
                class="member-user-card__name"
                @click="commonLogin"
              >登录/注册</span>
              <img
                class="member-user-card__level"
                referrerpolicy="no-referrer"
                :src="memberLevelBadge"
                alt=""
              />
            </div>
          </div>
          <p v-if="showExpired" class="member-user-card__desc">
            有效期至{{ userMemberInfo.deadlineEndTime }}
          </p>
          <p v-else-if="showPerson" class="member-user-card__desc">
            已有{{ openNumber }}人开通{{ currentTabLabel }}
          </p>
        </div>
        <div class="member-user-card__faq" @click="onFaqClick">
        </div>
        <div class="member-user-card__badge" v-if="showOpenBtn">
          <div class="member-user-card__open-btn" @click="onOpenClick">{{ openBtnText }}</div>
        </div>
      </div>

      <div class="member-benefits" :class="{ 'is-collapsed': !benefitsExpanded }">
        <div class="member-benefits__header">
          <span class="member-benefits__title">{{ benefitsTitle }}</span>
          <div class="member-benefits__toggle" @click="benefitsExpanded = !benefitsExpanded">
            <span>{{ benefitsExpanded ? '收起' : '展开' }}</span>
            <img
              class="member-benefits__toggle-icon"
              :class="{ 'is-collapsed': !benefitsExpanded }"
              referrerpolicy="no-referrer"
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/collapsed.png"
              alt=""
            />
          </div>
        </div>
        <div v-if="benefitsExpanded" class="member-benefits__grid">
          <div
            v-for="(item, index) in benefitList"
            :key="item.title + index"
            class="member-benefits__item"
            :class="{ 'is-unavailable': !isBenefitAvailable(item) }"
          >
            <div class="member-benefits__icon-wrap" @click="viewBenefits(index)">
              <img
                class="member-benefits__icon"
                referrerpolicy="no-referrer"
                :src="item.icon"
                alt=""
              />
              <img
                v-if="item.badgeIcon"
                class="member-benefits__badge"
                referrerpolicy="no-referrer"
                :src="item.badgeIcon"
                alt=""
              />
            </div>
            <span class="member-benefits__name">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 权益内容区 -->
    <div class="member-content">
      <!-- 学习工具 -->
      <study-tools
        :activeTab="activeTab"
        :userMemberInfo="userMemberInfo"
        :userInfo="userInfo"
      />

      <!-- 题库权益 -->
      <question-bank :userInfo="userInfo" :userMemberInfo="userMemberInfo" />
      <!-- AI助教 -->
      <ai-tutor
        :activeTab="activeTab"
        :aiCorrectCount="currentAiCorrectCount"
        :aiQuestionCount="currentAiQuestionCount"
      />
      <!-- 时政解读 / 学习视频 -->
      <study-video
        :activeTab="activeTab"
        :userMemberInfo="userMemberInfo"
        :userInfo="userInfo"
        :productId="politics"
      />

      <!-- 专属课程 -->
      <course
        :activeTab="activeTab"
        :userInfo="userInfo"
        :userMemberInfo="userMemberInfo"
        :productIds="course.slice() || []"
      />

      <!-- 专属优惠券 -->
      <coupons
        v-if="couponIds.length"
        :activeTab="activeTab"
        :userInfo="userInfo"
        :userMemberInfo="userMemberInfo"
        :couponIds="couponIds"
        @needLogin="commonLogin"
      />

      <!-- 学习服务 -->
      <study-server
        :activeTab="activeTab"
        :userMemberInfo="userMemberInfo"
        :userInfo="userInfo"
        :benefitList="benefitList"
      />

      <!-- 会员权益对比图：随 tab 切换 1/2/3 -->
      <div class="member-benefits-pic">
         <div class="title">会员权益对比</div>
        <img class="member-benefits-pic__img" :src="benefitsCompareImg" alt="会员权益" />
      </div>
    </div>

    <!-- 底部开通按钮：当前档已开通或更高档覆盖时隐藏 -->
    <div class="member-footer" v-if="showOpenBtn">
      <button class="member-footer__btn" type="button" @click="onOpenClick">{{ openBtnText }}</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import {
  getUserMember,
  getMemberLevelInfo,
  getNewMemberBenefits,
  getMemberDetail,
  reqCombinationDetail,
  reqCombinationlist,
  getClassType,
  reqSubOrder,
} from '@/api/member/index';
import StudyTools from './components/StudyTools/index.vue';
import QuestionBank from './components/QuestionBank/index.vue';
import StudyVideo from './components/StudyVideo/index.vue';
import Course from './components/Courses/index.vue';
import AiTutor from './components/AiTutor/index.vue';
import Coupons from './components/Coupons/index.vue';
import StudyServer from './components/StudyServer/index.vue';
import FaqModal from './components/FaqModal/index.vue';
import OpenMemberPopup from './components/OpenMemberPopup/index.vue';

// 高阶卡(25) / 尊享卡(30) 权益角标
const BENEFIT_BADGE_VIP =
  'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/svip.png';
const BENEFIT_BADGE_SVIP =
  'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/vip.png';
// 会员权益对比图：基础 / VIP / SVIP
const BENEFITS_COMPARE_IMG = {
  20: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/benefits-1.png',
  25: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/benefits-2.png',
  30: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/benefits-3.png',
};
const MEMBER_LEVEL_BADGE = {
  20: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-20-new.png',
  25: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-25-new.png',
  30: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-30-new.png',
};

export default {
  components: {
    StudyTools,
    QuestionBank,
    StudyVideo,
    Course,
    AiTutor,
    Coupons,
    StudyServer,
    FaqModal,
    OpenMemberPopup,
  },
  data() {
    return {
      activeTab: 20, // 20 基础会员 25 VIP 30 SVIP
      benefitsExpanded: true,
      politics: '', // 时政课程 productId
      course: [], // 专属课程 productId（排除时政 / 学习服务）
      server: '', // 学习服务绑定 productId
      couponIds: [],
      faq: '',
      isFaqShow: false,
      isOpenPopup: false,
      // 领取试用后，等用户手动关闭弹窗再刷新父页开通状态
      pendingRefreshOnPopupClose: false,
      gioVisitUserId: '',
      isHideTitle: false,
      isMini: this.$root.miniprogram || false,
      // 后台是否配置了试用套餐（memberLevel === 10），对齐旧页 showTrialBtn
      showTrialBtn: false,
      // 试用套餐 id
      trialPackageId: null,
      // member-level 接口原始列表（试用判断以此为准）
      memberLevelList: [],
      userMemberInfo: {
        level: 0, // 0 普通用户 10 试用会员 20 基础会员 25 VIP 30 SVIP
        levelName: '普通用户',
        deadlineStartTime: null,
        deadlineEndTime: null,
        isTryoutMember: null,
        beforeMemberLevel: null,
        productIds: '',
      },
      tabList: [
        { key: 'basic', label: '基础卡', memberLevel: 20 },
        { key: 'vip', label: '高阶卡', memberLevel: 25 },
        { key: 'svip', label: '尊享卡', memberLevel: 30 },
      ],
      // 各等级开通人数 / 套餐优惠券 / 时政 / 价格等（10 为试用套餐）
      memberLevelInfo: {
        10: {
          number: 0,
          packageId: null,
          packages: [],
          products: null,
          priceInfo: {},
          coupons: '',
          faq: '',
        },
        20: {
          number: 0,
          packageId: null,
          packages: [],
          priceInfo: {},
          coupons: '',
          faq: '',
          politics: '',
          allPolitics: '',
          server: '',
          allServer: '',
          aiCorrectCount: null,
          aiQuestionCount: null,
        },
        25: {
          number: 0,
          packageId: null,
          packages: [],
          priceInfo: {},
          coupons: '',
          faq: '',
          politics: '',
          allPolitics: '',
          server: '',
          allServer: '',
          aiCorrectCount: null,
          aiQuestionCount: null,
        },
        30: {
          number: 0,
          packageId: null,
          packages: [],
          priceInfo: {},
          coupons: '',
          faq: '',
          politics: '',
          allPolitics: '',
          server: '',
          allServer: '',
          aiCorrectCount: null,
          aiQuestionCount: null,
        },
      },
      benefitList: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
    activeTabIndex() {
      const index = this.tabList.findIndex(tab => tab.memberLevel === this.activeTab);
      return index > -1 ? index : 0;
    },
    currentTabLabel() {
      const tab = this.tabList.find(item => item.memberLevel === this.activeTab);
      return tab ? tab.label : '';
    },
    openNumber() {
      return this.memberLevelInfo[this.activeTab]?.number || 0;
    },
    /**
     * 用户有效会员档位（用于开通/升级/权益展开判断）
     * 试用/短周期按基础档 20；正式档 20 / 25 / 30；否则 0
     */
    memberTierLevel() {
      const level = Number(this.userMemberInfo.level) || 0;
      if ([10, 20, 40, 50, 60].includes(level)) return 20;
      if (level === 25 || level === 30) return level;
      return 0;
    },
    // 当前 tab 是否为「已购本档」（仅精确匹配；高档看低档不算）
    isBenefitsUnlocked() {
      const level = Number(this.userMemberInfo.level) || 0;
      const tab = Number(this.activeTab);
      if (tab === 20) return [10, 20, 40, 50, 60].includes(level);
      // VIP 25 / SVIP 30：必须与当前 tab 精确相等
      return level === tab;
    },
    // 当前 tab 对应用户已开通时，展示有效期
    showExpired() {
      return this.isBenefitsUnlocked;
    },
    // 当前 tab 未购买时，展示开通人数（与 showExpired 互斥）
    showPerson() {
      return !this.isBenefitsUnlocked;
    },
    benefitsTitle() {
      const prefix = this.isBenefitsUnlocked ? '已解锁' : '解锁';
      const count = (this.benefitList || []).filter(item => this.isBenefitAvailable(item)).length;
      return `${prefix}${count}项权益`;
    },
    benefitsCompareImg() {
      return BENEFITS_COMPARE_IMG[this.activeTab] || BENEFITS_COMPARE_IMG[20];
    },
    memberLevelBadge() {
      return MEMBER_LEVEL_BADGE[this.activeTab] || MEMBER_LEVEL_BADGE[20];
    },
    /**
     * 开通按钮展示：
     * 1. 已买当前档或更高档（试用10 视为覆盖基础20）→ 隐藏
     * 2. 已有较低档，切到更高档 → 展示「升级」
     * 3. 未开通 → 展示「立即开通」
     */
    showOpenBtn() {
      const level = Number(this.userMemberInfo.level) || 0;
      // 试用/短周期/基础会员：基础卡 tab 不展示开通（不可直接买基础）
      if (this.activeTab === 20 && [10, 20, 40, 50, 60].includes(level)) {
        return false;
      }
      return this.memberTierLevel < this.activeTab;
    },
    openBtnText() {
      return this.memberTierLevel > 0 ? '升级' : '立即开通';
    },
    // 当前 tab 下可选套餐（含 priceInfo）
    currentTabPackages() {
      return this.memberLevelInfo[this.activeTab]?.packages || [];
    },
    // 当前等级年卡套餐（memberPackageType === 2）
    currentYearPackage() {
      const packages = this.memberLevelInfo[this.activeTab]?.packages || [];
      return packages.find(pkg => Number(pkg.memberPackageType) === 2) || null;
    },
    // AI 批改 / 答疑次数取当前等级年卡的 memberServiceConfigDetail
    currentAiCorrectCount() {
      const count = this.currentYearPackage?.aiCorrectCount;
      return count == null ? 0 : Number(count);
    },
    currentAiQuestionCount() {
      const count = this.currentYearPackage?.aiQuestionCount;
      return count == null ? 0 : Number(count);
    },
    /**
     * 试用入口：后台配置了试用套餐，且用户未买过任何会员（level 无值）
     * 买过试用/基础/VIP/SVIP 等只要 level 有值就隐藏
     */
    showOpenTrial() {
      return !this.userMemberInfo.level && !!this.showTrialBtn;
    },
  },
  watch: {
    activeTab() {
      this.syncBenefitsExpanded();
    },
    'userMemberInfo.level'() {
      this.syncBenefitsExpanded();
    },
    // 刷新进页时 userInfo 可能晚于 created，就绪后再拉会员信息并定位 tab
    'userInfo.id': {
      async handler(id, prevId) {
        if (id && id !== prevId) {
          const ok = await this.fetchUserMemberAndSetTab();
          if (ok) this.setIds(this.activeTab);
        }
      },
    },
  },
  created() {
    this.initMemberCard();
  },
  mounted() {
    this.isHideTitle = this.$route.query.isHideTitle || false;
    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = value => {
      this.getAndroid(value);
    };
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
  },
  methods: {
    /**
     * 是否已购买「当前 tab 对应等级」
     * - 基础 tab(20)：10/20/40/50/60 算已购
     * - VIP(25) / SVIP(30)：必须 level 精确相等
     */
    isCurrentTabPurchased(tab = this.activeTab) {
      const level = Number(this.userMemberInfo.level) || 0;
      const t = Number(tab);
      if (t === 20) return [10, 20, 40, 50, 60].includes(level);
      return level === t;
    },
    // 已购当前档 → 收起；未购（含高档切低档）→ 展开
    syncBenefitsExpanded() {
      this.benefitsExpanded = !this.isBenefitsUnlocked;
    },
    setTabActive(memberLevel) {
      this.activeTab = Number(memberLevel);
      this.setIds(this.activeTab);
      this.syncBenefitsExpanded();
    },
    // 与 UserCard.viewBenefits 一致：跳转会员权益详情
    viewBenefits(index) {
      this.$router.push({
        path: '/personalCenter/benefits',
        query: {
          activeTab: this.activeTab,
          hiddenNavigationBar: 1,
          index,
          back: 'back',
        },
      });
    },
    // App 回调会传入 mode，参数需保留
    init(mode) { // eslint-disable-line no-unused-vars
      return this.initMemberCard();
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.init();
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId ||
          ''}',wechatSource:'会员中心'}`;
      }
    },
    async initMemberCard() {
      await Promise.all([
        this.fetchMemberLevelNumber(),
        this.fetchBenefitList(),
        this.initDefaultTab(),
      ]);
      await Promise.all([
        this.fetchPackageDetailConfig(),
        this.fetchMemberDetailConfig(),
      ]);
      this.setIds(this.activeTab);
      this.syncBenefitsExpanded();
    },
    hasLoginCredential() {
      const token = window.localStorage.getItem('accessToken');
      const validToken = !!(token && token !== 'null' && token !== '(null)');
      return validToken || !!this.userInfo.id;
    },
    // 拉取用户会员信息，并按等级定位 tab / 同步权益展开
    async fetchUserMemberAndSetTab() {
      if (!this.hasLoginCredential()) return false;
      try {
        const userMemberInfoTemp = await getUserMember();
        if (!userMemberInfoTemp) return false;

        const {
          deadlineEndTime,
          level: rawLevel,
          memberLevel,
          productIds,
          ...rest
        } = userMemberInfoTemp;
        // 兼容 level / memberLevel 字段
        const level = Number(rawLevel != null ? rawLevel : memberLevel) || 0;
        this.userMemberInfo = {
          ...rest,
          level,
          productIds: productIds || '',
          deadlineEndTime: deadlineEndTime?.split(' ')[0] || '',
        };

        const queryTab = Number(this.$route.query.activeTab);
        const validLevels = this.tabList.map(tab => tab.memberLevel);
        if (validLevels.includes(level)) {
          // 已购正式档（20/25/30）→ 默认定位到对应 tab
          this.activeTab = level;
        } else if ([10, 40, 50, 60].includes(level)) {
          this.activeTab = 20;
        } else if (validLevels.includes(queryTab)) {
          this.activeTab = queryTab;
        } else {
          this.activeTab = 20;
        }

        this.syncBenefitsExpanded();
        return true;
      } catch (e) {
        return false;
      }
    },
    // 默认选中：已购买优先对应用户等级，否则看路由 activeTab，再否则基础卡
    async initDefaultTab() {
      const loaded = await this.fetchUserMemberAndSetTab();
      if (loaded) return;

      const queryTab = Number(this.$route.query.activeTab);
      const validLevels = this.tabList.map(tab => tab.memberLevel);
      if (validLevels.includes(queryTab)) {
        this.activeTab = queryTab;
      } else {
        this.activeTab = 20;
      }
      this.syncBenefitsExpanded();
    },
    // 拉取会员权益列表
    async fetchBenefitList() {
      try {
        const data = await getNewMemberBenefits();
        this.benefitList = (data || []).map(item => {
          const { title, icon, memberLevels } = JSON.parse(item.remark || '{}');
          return {
            title,
            icon,
            memberLevels: memberLevels || [],
            badgeIcon: this.getBenefitBadgeIcon(memberLevels),
          };
        });
      } catch (e) {
        this.benefitList = [];
      }
    },
    /**
     * 角标规则（按 memberLevels 组合）：
     * - [20] / [20,25,30]：通用或仅基础 → 无角标
     * - 含 25 不含 30（如 [25]、[20,25]）→ 高阶卡角标
     * - 含 30 不含 25（如 [30]、[20,30]）→ 尊享卡角标
     * - [25,30]：从高阶起 → 高阶卡角标
     */
    getBenefitBadgeIcon(memberLevels) {
      if (!Array.isArray(memberLevels) || !memberLevels.length) return '';
      const levels = memberLevels.map(Number);
      const has20 = levels.includes(20);
      const has25 = levels.includes(25);
      const has30 = levels.includes(30);

      if (has20 && has25 && has30) return '';
      if (has20 && !has25 && !has30) return '';
      if (has30 && !has25) return BENEFIT_BADGE_SVIP;
      if (has25 && !has30) return BENEFIT_BADGE_VIP;
      if (has25 && has30 && !has20) return BENEFIT_BADGE_VIP;
      return '';
    },
    /**
     * 当前 tab 是否拥有该权益（高档继承低档）：
     * - 仅基础 / 全档 → 20 / 25 / 30 都有
     * - 高阶（含 25 不含仅 30）→ 25 / 30 有
     * - 仅尊享（含 30 不含 25）→ 仅 30 有
     */
    isBenefitAvailable(item) {
      const tab = Number(this.activeTab);
      const levels = (item.memberLevels || []).map(Number);
      if (!levels.length) return false;
      const has20 = levels.includes(20);
      const has25 = levels.includes(25);
      const has30 = levels.includes(30);
      if ((has20 && has25 && has30) || (has20 && !has25 && !has30)) {
        return [20, 25, 30].includes(tab);
      }
      if (has30 && !has25) return tab === 30;
      if (has25) return [25, 30].includes(tab);
      return levels.includes(tab);
    },
    // 拉取各等级开通人数 + 套餐列表，并请求价格（含 25）
    // memberPackageType / memberType：0-不适用(基础单套餐) 1-季卡 2-年卡；仅 25/30 分季年卡
    async fetchMemberLevelNumber() {
      try {
        const MemberLevelInfo = (await getMemberLevelInfo()) || [];
        const list = Array.isArray(MemberLevelInfo) ? MemberLevelInfo : [];
        this.memberLevelList = list;

        // 对齐旧页：memberLevel === 10 → showTrialBtn = true
        this.showTrialBtn = false;
        this.trialPackageId = null;
        list.forEach((item) => {
          if (Number(item.memberLevel) === 10 && item.packageId) {
            this.showTrialBtn = true;
            this.trialPackageId = item.packageId;
          }
        });

        const packageIdToMemberLevel = {};
        const allPackageIds = [];
        const validLevels = [10, 20, 25, 30];

        // 确保各档位容器存在
        validLevels.forEach(level => {
          if (!this.memberLevelInfo[level]) {
            this.$set(this.memberLevelInfo, level, {
              number: 0,
              packageId: null,
              packages: [],
              products: null,
              priceInfo: {},
              coupons: '',
              faq: '',
            });
          } else {
            this.$set(this.memberLevelInfo, level, {
              ...this.memberLevelInfo[level],
              packages: [],
              packageId: null,
              products: null,
              priceInfo: {},
            });
          }
        });

        list.forEach(item => {
          const level = Number(item.memberLevel);
          if (!validLevels.includes(level)) return;

          if (!this.memberLevelInfo[level]) {
            this.$set(this.memberLevelInfo, level, {
              number: 0,
              packageId: null,
              packages: [],
              products: null,
              priceInfo: {},
              coupons: '',
              faq: '',
            });
          }

          const packageId = item.packageId;
          packageIdToMemberLevel[packageId] = level;
          allPackageIds.push(packageId);

          if (level === 10) {
            this.showTrialBtn = true;
            this.trialPackageId = packageId;
          }

          const packages = [...(this.memberLevelInfo[level].packages || [])];
          packages.push(this.buildMemberPackage(item, level));

          this.$set(this.memberLevelInfo, level, {
            ...this.memberLevelInfo[level],
            number: item.number,
            packageId,
            packages,
          });
        });

        // 排序：季卡在前、年卡在后；推荐年卡（基础档仅一种则推荐它）
        validLevels.forEach(level => {
          let packages = [...(this.memberLevelInfo[level]?.packages || [])];
          if (!packages.length) return;

          packages.sort((a, b) => (a.memberPackageType || 0) - (b.memberPackageType || 0));

          const yearIdx = packages.findIndex(pkg => pkg.memberPackageType === 2);
          const recommendIdx = yearIdx > -1 ? yearIdx : packages.length - 1;
          packages = packages.map((pkg, index) => ({
            ...pkg,
            recommend: index === recommendIdx,
          }));

          const recommendPkg = packages[recommendIdx];
          this.$set(this.memberLevelInfo, level, {
            ...this.memberLevelInfo[level],
            packages,
            packageId: recommendPkg?.packageId || this.memberLevelInfo[level].packageId,
          });
        });

        await this.fetchPriceInfo(allPackageIds, packageIdToMemberLevel);
      } catch (e) {
        // 人数/价格失败不影响试用标志（上方已按列表落过）
      }
    },
    /**
     * 组装弹窗套餐项
     * - 基础 20：无季/年区分，默认单套餐
     * - 中阶 25 / 高阶 30：按 memberPackageType 展示季卡(1)/年卡(2)
     */
    buildMemberPackage(item, level) {
      const packageId = item.packageId;
      // 接口字段兼容 memberPackageType / memberType
      const memberPackageType = Number(
        item.memberPackageType !== undefined && item.memberPackageType !== null
          ? item.memberPackageType
          : item.memberType !== undefined && item.memberType !== null
            ? item.memberType
            : 0,
      );

      let name = item.packageName || item.name || '';
      let days = 365;

      if (level === 25 || level === 30) {
        if (memberPackageType === 1) {
          name = '季卡';
          days = 90;
        } else if (memberPackageType === 2) {
          name = '年卡';
          days = 365;
        }
      }

      return {
        id: packageId,
        packageId,
        name,
        memberPackageType,
        price: '',
        originalPrice: '',
        endTime: '',
        days,
        recommend: false,
      };
    },
    // 与旧页 setPriceInfo 一致：promotionLabel ? payPrice : sellPrice
    async fetchPriceInfo(allPackageIds, packageIdToMemberLevel) {
      if (!allPackageIds.length) return;
      try {
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        const data = await reqCombinationlist(endPoint, allPackageIds);
        (data || []).forEach(item => {
          const {
            packageDiscountRespVO,
            originalPrice,
            sellPrice,
            packageId,
            packageName,
          } = item;
          const { payPrice, promotionLabel, promotionEndTime } = packageDiscountRespVO || {};
          const priceInfo = {
            price: promotionLabel ? payPrice : sellPrice,
            originalPrice: promotionLabel ? sellPrice : originalPrice,
            endTime: promotionEndTime,
          };
          const level = packageIdToMemberLevel[packageId];
          if (!this.memberLevelInfo[level]) return;

          const packages = (this.memberLevelInfo[level].packages || []).map(pkg => {
            if (pkg.packageId !== packageId) return pkg;
            // 基础档无季/年类型时，可用套餐名兜底；25/30 已用类型命名，勿被覆盖
            const keepTypedName = Number(level) === 25 || Number(level) === 30;
            return {
              ...pkg,
              name: keepTypedName ? pkg.name : (pkg.name || packageName || ''),
              price: priceInfo.price,
              originalPrice: priceInfo.originalPrice,
              endTime: priceInfo.endTime,
            };
          });
          const recommendPkg = packages.find(pkg => pkg.recommend) || packages[packages.length - 1];

          this.$set(this.memberLevelInfo, level, {
            ...this.memberLevelInfo[level],
            packages,
            priceInfo: recommendPkg
              ? {
                  price: recommendPkg.price,
                  originalPrice: recommendPkg.originalPrice,
                  endTime: recommendPkg.endTime,
                }
              : priceInfo,
          });
        });
      } catch (e) {
        // 价格失败不影响其他模块
      }
    },
    // 拉取各套餐详情：products / 优惠券 / FAQ（与旧页 setProductInfo 一致）
    async fetchPackageDetailConfig() {
      let classType = '';
      const tasks = [];

      Object.keys(this.memberLevelInfo).forEach(level => {
        const packages = this.memberLevelInfo[level]?.packages || [];
        packages.forEach(pkg => {
          if (!pkg.packageId) return;
          tasks.push(
            (async () => {
              try {
                const data = await reqCombinationDetail(pkg.packageId);
                const {
                  packageId,
                  packageProductRespList,
                  faq,
                  packageAttributeVOList,
                  memberServiceConfigDetail,
                } = data || {};
                const orderDetailArr = (packageProductRespList || []).map(subItem => {
                  const { packageProductSkuWebRespList, productId } = subItem;
                  const { skuId } = packageProductSkuWebRespList[0];
                  if (packageAttributeVOList?.[0]?.dataJson) {
                    classType = packageAttributeVOList[0].dataJson;
                  }
                  return {
                    productId,
                    skuId,
                    packageId,
                  };
                });
                const coupons =
                  memberServiceConfigDetail?.couponDetailList
                    ?.map(item => item.couponId)
                    .join(',') || '';
                const aiCorrectCount = memberServiceConfigDetail?.aiCorrectCount;
                const aiQuestionCount = memberServiceConfigDetail?.aiQuestionCount;

                const nextPackages = (this.memberLevelInfo[level].packages || []).map(item => {
                  if (item.packageId !== packageId) return item;
                  return {
                    ...item,
                    products: orderDetailArr,
                    coupons,
                    faq: faq || '',
                    aiCorrectCount,
                    aiQuestionCount,
                  };
                });
                const recommendPkg =
                  nextPackages.find(item => item.recommend) || nextPackages[nextPackages.length - 1];
                const yearPkg = nextPackages.find(item => Number(item.memberPackageType) === 2);

                const products = recommendPkg?.products || orderDetailArr;
                this.$set(this.memberLevelInfo, level, {
                  ...this.memberLevelInfo[level],
                  packages: nextPackages,
                  products,
                  productIds: products.map(item => item.productId),
                  coupons: recommendPkg?.coupons || coupons,
                  faq: recommendPkg?.faq || faq || '',
                  aiCorrectCount: yearPkg?.aiCorrectCount,
                  aiQuestionCount: yearPkg?.aiQuestionCount,
                });
              } catch (e) {
                // 单套餐失败不影响其他
              }
            })(),
          );
        });
      });

      await Promise.all(tasks);

      if (this.$root.miniprogram && classType) {
        try {
          const types = await getClassType();
          const status = (types || []).some(item => item.value === classType);
          this.$root.setMiniProgramBuy(status);
        } catch (e) {
          // ignore
        }
      }
    },
    // 拉取各等级时政 / 学习服务配置（MEMBER_PRODUCT_INFO）
    async fetchMemberDetailConfig() {
      try {
        const memberDetail = await getMemberDetail();
        (memberDetail || []).forEach(item => {
          const { code, remark } = item;
          if (!this.memberLevelInfo[code]) return;
          try {
            const { politics, allPolitics, server, allServer } = JSON.parse(remark || '{}');
            this.$set(this.memberLevelInfo, code, {
              ...this.memberLevelInfo[code],
              politics: politics || '',
              allPolitics: allPolitics || '',
              server: server || '',
              allServer: allServer || '',
            });
          } catch (e) {
            // remark 解析失败忽略
          }
        });
      } catch (e) {
        // 配置失败时 politics 保持空
      }
    },
    // 同步当前 tab 的时政 productId / 专属课程 / 优惠券（与旧页 setIds 一致）
    setIds(key) {
      const info = this.memberLevelInfo[key] || {};
      const {
        politics = '',
        allPolitics = '',
        server = '',
        allServer = '',
        coupons = '',
        productIds: levelProductIds = [],
        products = [],
      } = info;
      const { level, productIds } = this.userMemberInfo;
      if ([10, 40, 50, 60].includes(level) && productIds && allPolitics) {
        const productIdsArr = String(productIds).split(',').map(String);
        const allPoliticsArr = String(allPolitics).split(',').map(String);
        this.politics = productIdsArr.filter(v => allPoliticsArr.includes(v))[0] || '';
      } else {
        this.politics = politics || '';
      }
      if ([10, 40, 50, 60].includes(level) && productIds && allServer) {
        const productIdsArr = String(productIds).split(',').map(String);
        const allServerArr = String(allServer).split(',').map(String);
        this.server = productIdsArr.filter(v => allServerArr.includes(v))[0] || '';
      } else {
        this.server = server || '';
      }
      const packageProductIds = (levelProductIds.length
        ? levelProductIds
        : (products || []).map(item => item.productId)
      ).map(String).filter(Boolean);
      this.course = packageProductIds.filter(
        item => item !== String(server || '') && item !== String(politics || ''),
      );
      this.couponIds = String(coupons || '')
        .split(',')
        .filter(Boolean)
        .map(String);
    },
    onOpenClick() {
      if (!this.userInfo.id) {
        this.commonLogin();
        return;
      }
      // 立即开通 / 升级：都打开开通弹窗（弹窗内再区分支付或升级）
      this.isOpenPopup = true;
    },
    openChat() {
      const partnerId = this.userInfo.id || '';
      const chatUrl = `https://iqihang.sobot.com/chat/h5/v7/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${partnerId}`;
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: chatUrl,
          },
          false,
        );
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: '/subPackages/zhichi/zhichi',
        });
      } else {
        window.open(chatUrl);
      }
    },
    async closeOpenPopup() {
      this.isOpenPopup = false;
      // 领取试用（成功/失败）后，用户手动关闭弹窗时再刷新父页状态
      if (!this.pendingRefreshOnPopupClose) return;
      this.pendingRefreshOnPopupClose = false;
      await this.fetchUserMemberAndSetTab();
      this.syncBenefitsExpanded();
      this.setIds(this.activeTab);
    },
    onOpenUpgrade() {
      this.closeOpenPopup();
      this.openChat();
    },
    // 领取试用会员（等级 10）：不主动关弹窗，由用户点关闭
    onOpenTrial() {
      this.generateOrder(10);
    },
    // 弹窗支付：与旧页 generateOrder 一致
    onOpenPay(selectedPackage) {
      this.generateOrder(this.activeTab, selectedPackage);
    },
    generateOrder(level, selectedPackage) {
      if (!this.userInfo.id) {
        this.commonLogin();
        return;
      }
      switch (level) {
        case 0:
          break;
        case 10:
          this.receiveTrialMember();
          break;
        default:
          this.entryPayOrder(level, selectedPackage);
      }
    },
    // 领取试用会员（与旧页 receiveTrialMember 一致）
    async receiveTrialMember() {
      let referer = '';
      if (sessionStorage.getItem('fromPageUrl')) {
        const paramData = JSON.parse(sessionStorage.getItem('fromPageUrl'));
        referer = paramData.fromPageUrl ? paramData.fromPageUrl : paramData.fromPageUrlLast;
      }
      // eslint-disable-next-line
      let uuid = gio('getVisitUserId') || [];
      if (!this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${this.$route.query.liveRoomId ||
          ''}',wechatSource:'会员中心'}`;
      }
      const { packageId, products } = this.memberLevelInfo[10] || {};
      if (!packageId || !products || !products.length) {
        this.$toast('试用套餐信息加载中，请稍后重试');
        return;
      }
      const subData = {
        channelMark: 5,
        products: products.map(item => ({
          productId: item.productId,
          productSkuId: item.skuId,
          quantity: 1,
          type: 1,
          packageId,
        })),
        terminalMark: this.$global.terminalMark,
        orderReferer: referer,
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
        extendParam: this.gioVisitUserId,
        orderSource: '会员中心',
      };
      try {
        const { data, code } = await reqSubOrder(subData);
        // 无论成败都不关弹窗，关闭后由 closeOpenPopup 刷新父页
        this.pendingRefreshOnPopupClose = true;
        if (code !== 0 || Number(data.payAmount) !== 0) {
          this.$toast('未领取成功，请联系客服处理~');
          return;
        }
        this.$toast('领取成功');
        this.showTrialBtn = false;
        this.trialPackageId = null;
        // 先本地更新，弹窗内试用入口可立即隐藏；完整状态等关闭时再拉接口
        this.userMemberInfo = {
          ...this.userMemberInfo,
          level: 10,
        };
        if (this.$root.$data.isApp) {
          this.$sendToApp('onFreeCourseSuccess', { type: 1, level: 10 }, false);
        }
      } catch (e) {
        this.pendingRefreshOnPopupClose = true;
        this.$toast('未领取成功，请联系客服处理~');
      }
    },
    // 支付下单跳转（与旧页 entryPayOrder 一致，支持当前选中套餐）
    entryPayOrder(level, selectedPackage) {
      const levelInfo = this.memberLevelInfo[level] || {};
      const pkg =
        selectedPackage && selectedPackage.packageId
          ? selectedPackage
          : (levelInfo.packages || []).find(item => item.recommend)
            || (levelInfo.packages || [])[0]
            || {};
      const packageId = pkg.packageId || levelInfo.packageId;
      const products = pkg.products || levelInfo.products;

      if (!packageId || !products || !products.length) {
        this.$toast('套餐信息加载中，请稍后重试');
        return;
      }

      this.closeOpenPopup();

      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'buyCourseNew',
          {
            product: JSON.stringify(products),
            packageId,
            miniBeforePageName: 8,
            level,
          },
          false,
        );
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        const { origin } = window.location;
        let path = `${origin}/ark/payOrder?product=${JSON.stringify(
          products,
        )}&packageId=${packageId}&miniBeforePageName=8&`;
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach(item => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        const miniBeforePageName = localStorage.getItem('miniBeforePageName');
        if (!miniBeforePageName) {
          localStorage.setItem('miniBeforePageName', 8);
        }
        this.$router.push({
          path: '/payOrder',
          query: {
            product: JSON.stringify(products),
            packageId,
          },
        });
      }
    },
    // 与 UserCard 的 showFaq(activeTab) 一致
    onFaqClick() {
      this.showFaq(this.activeTab);
    },
    showFaq(key) {
      const { faq } = this.memberLevelInfo[key] || {};
      this.faq = faq || '';
      this.isFaqShow = true;
    },
    closeFaq() {
      this.faq = '';
      this.isFaqShow = false;
    },
    commonLogin() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          if (params) {
            const paramsMap = new Map();
            params.forEach(item => {
              const [key, value] = item.split('=');
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of entries) {
              if (ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
          }
        }
        const redirctUrl = encodeURIComponent(
          `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.member-page {
  position: relative;
  width: 750px;
  min-height: 100vh;
  padding-bottom: 160px;
  overflow-x: hidden;
  background-color: #fff;
}

.member__top {
  height: 100px;
}

.member-hero {
  position: relative;
  z-index: 2;
  padding: 27px 36px 72px 29px;
  background: linear-gradient(
    180deg,
    rgba(242, 212, 170, 1) 0%,
    rgba(168, 119, 76, 1) 50%,
    rgba(168, 119, 76, 1) 100%
  );

  &--25 {
    background: linear-gradient(
      180deg,
      rgba(201, 230, 251, 1) 0%,
      rgba(120, 172, 215, 1) 50%,
      rgba(94, 158, 208, 1) 100%
    );
  }

  &--30 {
    background: rgba(19, 17, 25, 1);

    .member-tabs__item {
      color: #fff;
    }

    .member-tabs__indicator::after {
      background-color: #fff;
    }
  }
}

.member-tabs {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 605px;
  margin: 0 auto;

  &__item {
    flex: 1;
    color: #333;
    font-weight: 400;
    font-size: 29px;
    line-height: 40px;
    white-space: nowrap;
    text-align: center;

    &.is-active {
      font-weight: 600;
    }
  }

  &__indicator {
    position: absolute;
    bottom: -11px;
    left: 0;
    width: 33.333%;
    height: 5px;
    transition: transform 0.2s ease;

    &::after {
      display: block;
      width: 33px;
      height: 5px;
      margin: 0 auto;
      background-color: #333;
      border-radius: 4px;
      content: '';
    }
  }
}

.member-user-card {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 678px;
  height: 263px;
  margin-top: 36px;
  padding: 62px 0 35px 35px;
  background-image: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-top-bg.png);
  background-size: 100% 100%;

  .member-hero--25 & {
    background-image: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-top-bg2.png);
  }

  .member-hero--30 & {
    background-image: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-top-bg3.png);

    .member-user-card__name,
    .member-user-card__desc {
      color: #fae1d0;
    }
  }

  &__main {
    display: flex;
    flex-direction: column;
  }

  &__profile {
    display: flex;
    align-items: center;
  }

  &__avatar {
    width: 109px;
    height: 109px;
    border-radius: 50%;
  }

  &__meta {
    display: flex;
    flex-direction: column;
    margin-left: 22px;
  }

  &__name {
    color: #60371c;
    font-weight: 500;
    font-size: 36px;
    line-height: 51px;
    white-space: nowrap;
  }

  &__level {
    display: block;
    width: 111px;
    height: auto;
    margin-top: 4px;
  }

  &__desc {
    margin-top: 25px;
    color: #60371c;
    font-size: 22px;
    line-height: 31px;
    white-space: nowrap;
  }

  &__faq {
    width: 43px;
    height: 109px;
    margin-top: 30px;
    background: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-qa.png) no-repeat;
    background-size: 100%;

    .member-hero--25 & {
      background-image: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-qa1.png);
    }

    .member-hero--30 & {
      background-image: url(https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-qa2.png);
    }
  }

  &__badge {
    position: absolute;
    top: -25px;
    left: 428px;
  }

  &__open-btn {
    min-width: 150px;
    margin: 163px 11px -11px;
    padding: 5px 29px 7px;
    color: #ffe2c4;
    font-weight: 500;
    font-size: 25px;
    line-height: 36px;
    white-space: nowrap;
    text-align: center;
    background: linear-gradient( 0deg, #211C20 0%, #3B3734 100%);
    border-radius: 27px;
  }
}

.member-benefits {
  position: relative;
  margin-top: 18px;
  padding: 22px 25px 29px;
  overflow: hidden;
  background: linear-gradient(180deg, #131119 0%, #0f0e13 100%);
  border-radius: 20px;

  .member-hero--20 &,
  .member-hero--25 & {
    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      padding: 2px;
      background: linear-gradient(
        180deg,
        rgba(208, 184, 176, 1) 0%,
        rgba(15, 14, 19, 1) 100%
      );
      border-radius: inherit;
      content: '';
      pointer-events: none;
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }
  }

  .member-hero--30 & {
    background:
      linear-gradient(180deg, #131119 0%, #0f0e13 100%) padding-box,
      linear-gradient(180deg, rgba(208, 184, 176, 1) 0%, rgba(15, 14, 19, 1) 100%) border-box;
    border: 2px solid transparent;
  }

  &.is-collapsed {
    padding-bottom: 22px;

    .member-benefits__grid {
      display: none;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 627px;
  }

  &__title {
    color: #fff;
    font-size: 25px;
    line-height: 36px;
    white-space: nowrap;
  }

  &__toggle {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 22px;
    line-height: 31px;
    white-space: nowrap;
  }

  &__toggle-icon {
    width: 25px;
    height: 25px;
    margin-left: 7px;
    transition: transform 0.2s ease;

    &.is-collapsed {
      transform: rotate(180deg);
    }
  }

  &__grid {
    display: flex;
    flex-wrap: wrap;
    width: 612px;
    margin: 29px auto 0;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 20%;
    margin-bottom: 22px;

    &.is-unavailable {
      -webkit-filter: grayscale(1);
      filter: grayscale(1);
    }
  }

  &__icon-wrap {
    position: relative;
    width: 72px;
    height: 72px;
    cursor: pointer;
  }

  &__icon {
    display: block;
    width: 72px;
    height: 72px;
  }

  &__badge {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 100%;
     width: 47px;
    height: auto;
    height: 20px;
    margin: 0 auto;
    pointer-events: none;
  }

  &__name {
    margin-top: 11px;
    color: #dddddf;
    font-size: 22px;
    line-height: 31px;
    white-space: nowrap;
    text-align: center;
  }
}

.member-content {
  position: relative;
  z-index: 1;
  z-index: 2;
  margin-top: -36px;
  padding: 54px 0 2px;
  background-color: #f7f8fc;
  border-radius: 36px 36px 0 0;
}

.member-section {
  margin-bottom: 36px;

  &__title {
    margin: 0 36px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 678px;
    margin: 0 auto;

    .member-section__title {
      margin: 0;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    color: #999;
    font-size: 22px;
    line-height: 31px;
    white-space: nowrap;
  }

  &__link-icon {
    width: 9px;
    height: 16px;
    margin-left: 7px;
  }
}

.member-benefits-pic {
  width: 678px;
  margin: 40px auto 0;
  .title{
    width: 100%;
  margin-bottom: 22px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
  }

  &__img {
    display: block;
    width: 678px;
    height: auto;
  }
}

.member-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding: 22px 36px calc(22px + env(safe-area-inset-bottom));
  background-color: #fff;
  border-radius: 22px 22px 0 0;
  box-shadow: 0 -4px 14px 0 rgba(0, 0, 0, 0.05);

  &__btn {
    display: block;
    width: 100%;
    padding: 18px 0;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
    text-align: center;
    background-color: #ff7f41;
    border: none;
    border-radius: 49px;
  }
}
</style>
